import getActionsByDocument from '../../../../../components/logs/actions';

const DOCUMENT = 'ACCREDITATIONS_LOGS_';

export default getActionsByDocument(DOCUMENT);
